function h(p, a) {
  switch (p) {
    case 0:
      return function() {
        return a.apply(this, arguments);
      };
    case 1:
      return function(t) {
        return a.apply(this, arguments);
      };
    case 2:
      return function(t, r) {
        return a.apply(this, arguments);
      };
    case 3:
      return function(t, r, e) {
        return a.apply(this, arguments);
      };
    case 4:
      return function(t, r, e, n) {
        return a.apply(this, arguments);
      };
    case 5:
      return function(t, r, e, n, u) {
        return a.apply(this, arguments);
      };
    case 6:
      return function(t, r, e, n, u, s) {
        return a.apply(this, arguments);
      };
    case 7:
      return function(t, r, e, n, u, s, i) {
        return a.apply(this, arguments);
      };
    case 8:
      return function(t, r, e, n, u, s, i, c) {
        return a.apply(this, arguments);
      };
    case 9:
      return function(t, r, e, n, u, s, i, c, o) {
        return a.apply(this, arguments);
      };
    case 10:
      return function(t, r, e, n, u, s, i, c, o, g) {
        return a.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
export {
  h as default
};
